import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const InvoiceActivationServices = {
  async saveInvoiceActivation(payload) {
    var url = `api/Save_InvoiceActivation`;
    return await ApiService.post(url, payload);
  },


  async dataSourceConfig(URL, Code, orderby) {

    const requestScreenData = {
      url: "api/" + URL,
      filter: `(CustomerInvoice eq ${Code})`,
      orderby: orderby
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getByCode(Code) {
    const requestScreenData = {
      url: "api/DespatchedCustomerInvoice",
      top: "1",
      filter: `InvoiceNo eq ${Code}`
    };

    return await ApiService.oDataGet(requestScreenData);
  }, // AlmondcoDespatchedSlidingScale

  async getAlmondcoDespatchedSlidingScale(SalesOrderCode) {
    const requestScreenData = {
      url: "api/AlmondcoDespatchedSlidingScale",
      filter: `SalesOrder eq ${SalesOrderCode}`,
    };

    return await ApiService.oDataGet(requestScreenData);

  }
}
export { InvoiceActivationServices };